export default {
  markerLayersToEdit: null,
  markerLayersMap: {
    buildings: [
      /*{
        id: 1,
        name: 'Здание 1',
        type: 'building',
        isEditable: false,
        coordinates: [54, 44]
      },
      {
        id: 3,
        name: 'Здание 3',
        type: 'building',
        isEditable: false,
        coordinates: [53, 43]
      },
      {
        id: 4,
        name: 'Здание 4',
        type: 'building',
        isEditable: false,
        coordinates: [49, 55]
      },*/
    ],
    containerplatforms: [
      /*{
        id: 1,
        name: 'КП 1',
        isEditable: false,
        type: 'containerplatform',
        coordinates: [55, 45]
      },
      {
        id: 3,
        name: 'КП 3',
        isEditable: false,
        type: 'containerplatform',
        coordinates: [56, 46]
      },
      {
        id: 4,
        name: 'КП 4',
        isEditable: false,
        type: 'containerplatform',
        coordinates: [58, 55]
      },*/
    ]
  },
  markerLayersMapPopup: {
    buildings: [],
    containerplatforms: []
  },
  markerLayersMapUpdated: [],
  markerLayersEmitter: null,
  markerLayersEmitterContainerPlatform: null,
  markerLayersBuilding: null,
  markerLayersBuildingEmitter: null,
  markerLayersContainerPlatform: null,
  markerLayersContainer: null,
  markerLayersContainers: [],
  markerLayersEmitters: [],
  markerLayersEmitterCategories: [],
  markerLayersContainerPlatforms: [],
  markerLayersContainerMaterials: [],
  markerLayersContainerTypes: [],
  markerLayersContainerGraphics: [],
}



// WEBPACK FOOTER //
// ./src/store/markerLayers/defaults.js